import Layout2 from '@/layout/Layout2'
let ja = require('../../common/lang/ja')
let zh = require('../../common/lang/zh-CN')

export default [{
  path: '/activitys',
  component: Layout2,
  meta: {
    zhtitle: zh.m.aside.nav.ACTIVITYS_TUBE,
    jatitle: ja.m.aside.nav.ACTIVITYS_TUBE
  },
  children: [{
    path: '',
    name: 'activitys',
    component: () => import( /* webpackChunkName: "jp.activitys" */ '@/merchanAdmin/activitys/ActivitysList'),
    meta: {
      zhtitle: zh.m.aside.nav.ACTIVITYS_TUBE,
      jatitle: ja.m.aside.nav.ACTIVITYS_TUBE,
      pername: "activity_setting"
    },
  }, {
    path: '/activityscreate',
    name: 'activityscreate',
    component: () => import( /* webpackChunkName: "jp.activitys" */ '@/merchanAdmin/activitys/ActivitysDetail'),
    meta: {
      zhtitle: zh.m.router.common.CREATE,
      jatitle: ja.m.router.common.CREATE,
      pername: "activity_setting"
    },
   
  }, {
    path: '/activitysdetail',
    name: 'activitysdetail',
    component: () => import( /* webpackChunkName: "jp.activitys" */ '@/merchanAdmin/activitys/ActivitysDetail'),
    meta: {
      zhtitle: zh.m.router.common.EDIT,
      jatitle: ja.m.router.common.EDIT,
      pername: "activity_setting"
    }
  }
  ]
}]
